import { createContext } from "react";

interface IContextFinesSecurity {
  loading: boolean;
  setLoading: (val: boolean) => void;
}

export const ContextFinesSecurity = createContext<IContextFinesSecurity>({
  loading: false,
  setLoading: () => {},
});